export const STAFF_FIRST_TIME_VIDEO = {
    'title': 'Staff Dashboard - New User Overview',
    'link': 'https://www.youtube.com/watch?v=YIh0YZ5Ip6E'
};



// WEBPACK FOOTER //
// ./src/components/staffDashboard/Constants.js